<!--
/*
 * Компонент AdminTransactions — просмотр транзакций пользователей
 *
 * Основные функции:
 * - Загрузка списка транзакций с сервера с фильтрацией
 * - Универсальная фильтрация по ID (транзакции или пользователя) через composable
 * - Делегирует отображение и фильтрацию в TransactionList
 */
-->
<script setup lang="ts">
// Хук жизненного цикла Vue
import { onMounted } from 'vue'
// Определение размера экрана — для динамического padding
import { useDisplay } from 'vuetify'
// Утилита определения Telegram-контекста
import { isTelegram } from '@/utils/isTelegram'
// Компонент заголовка секции
import SectionHeader from '@/components/SectionHeader.vue'
// Переиспользуемый список транзакций с фильтрацией и диалогом отмены
import TransactionList from '@/modules/admin/components/TransactionList.vue'
// Composable фильтрации транзакций — свободный поиск по ID транзакции / пользователя
import { useTransactionFilter } from '@/modules/admin/utils/useTransactionFilter'

// Определение мобильного экрана для динамического padding
const { mobile } = useDisplay()

// Composable фильтрации транзакций (свободный режим — без fixedUserID)
const { filterID, loadTransactions, onStatusChanged } = useTransactionFilter()

// Загрузка транзакций при монтировании компонента с дефолтным статусом "Завершена"
onMounted(async () => await loadTransactions())
</script>

<template>
  <div class="d-flex flex-column ga-4 pt-4" :class="{ 'pa-4': isTelegram() || mobile }">
    <!-- Навигация -->
    <header>
      <section-header />
    </header>

    <!-- Универсальный фильтр по ID транзакции или пользователя -->
    <v-text-field
      v-model="filterID"
      label="Фильтр по ID"
      variant="outlined"
      density="compact"
      hide-details
      clearable
    />

    <!-- Список транзакций с фильтрацией и диалогом отмены -->
    <transaction-list
      @status-changed="onStatusChanged"
      @cancelled="loadTransactions"
    />
  </div>
</template>

<style scoped></style>
